import { TemplateData, TemplateParams } from '.';

const courseDeadlineEmailList = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseAdminUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.courseDeadlineExpiringForUsers} ${messages.courseInCourse}.
      </p>
      <p>
        {{usersList}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.courseDeadlineExpiring} ${messages.courseInCourse}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseAdminUrl: {
      label: messages.commonCourseAdminLink,
      example: `${serverConfig.adminUrl}/courses/test-course/follow/users`
    },
    usersList: {
      label: messages.emailExpiringDeadlinesUsersList
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCourseDeadlineEmailList
});

export default courseDeadlineEmailList;
